import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n	@media ",
        " {\n		display: none;\n	}\n	display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n	@media (max-width: 1068px) {\n		display: none;\n	}\n	display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n	@media ",
        " {\n		display: none;\n	}\n	display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n	@media (min-width: 1068px) {\n		display: none;\n	}\n	display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { mediaQueries } from "~/styles/mixins";
import styled from "styled-components";
export var LargeScreenCssSwitch = styled.div.withConfig({
    componentId: "sc-f6bb99f1-0"
})(_templateObject(), mediaQueries.belowLarge);
export var LargeScreenCssSwitchLongerLangs = styled.div.withConfig({
    componentId: "sc-f6bb99f1-1"
})(_templateObject1());
export var SmallScreenCssSwitch = styled.div.withConfig({
    componentId: "sc-f6bb99f1-2"
})(_templateObject2(), mediaQueries.large);
export var SmallScreenCssSwitchLongerLangs = styled.div.withConfig({
    componentId: "sc-f6bb99f1-3"
})(_templateObject3());
